import React from "react";
import { aboutInfo } from "../lib/data";
import type { AboutDetail } from "../lib/types";

function AboutSection() {
  return (
    <div className="opacity-0-start animate-fade-in-d1 flex flex-col gap-6">
      <h2 className="text-xl font-bold">About Me</h2>

      <div className="bg-bg-surface border border-border rounded-lg p-7 flex flex-col gap-4">
        <p className="text-md text-content-secondary leading-relaxed">
          {aboutInfo.bio}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-2">
          {aboutInfo.details.map((item: AboutDetail) => (
            <div key={item.label}>
              <div className="text-2xs text-content-muted font-mono uppercase tracking-widest mb-1">
                {item.label}
              </div>
              {item.href ? (
                <a
                  href={item.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-base text-brand no-underline hover:underline"
                >
                  {item.value}
                </a>
              ) : (
                <div className="text-base text-content">{item.value}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutSection;